import React from "react";
import {Button, Card, Form, Modal, Spin} from "antd";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import {fetchSubMasterFilter,} from "../../appRedux/actions";
import {connect} from "react-redux";
import SubList from "../SubList";
import {createResource as manpower} from "../../appRedux/actions/Manpower";
import {createResource as documentType} from "../../appRedux/actions/DocumentType";
import {createResource as location} from "../../appRedux/actions/Location";
import {createResource as client} from "../../appRedux/actions/Client";
import {createResource as assetType} from "../../appRedux/actions/AssetType";
import {createResource as interval} from "../../appRedux/actions/Interval";
import {createResource as jobType} from "../../appRedux/actions/JobType";
import {createResource as owner} from "../../appRedux/actions/Owner";
import {createResource as sparePart} from "../../appRedux/actions/SparePart";
import {createResource as sparePartType} from "../../appRedux/actions/SparePartType";
import {createResource as status} from "../../appRedux/actions/Status";
import {createResource as unitOfMeasurement} from "../../appRedux/actions/UnitOfMeasurement";
import {createResource as vendor} from "../../appRedux/actions/Vendor";
import {createResource as activityType} from "../../appRedux/actions/ActivityType";
import {createResource as fuelType} from '../../appRedux/actions/FuelType';
import {createResource as conditionOfAsset} from '../../appRedux/actions/ConditionOfAsset';
import {createResource as labour} from '../../appRedux/actions/Labour';
import {createResource as assetSubType} from "../../appRedux/actions/EquipmentSubType";
import {createResource as assetMake} from "../../appRedux/actions/AssetMake";
import {createResource as subAssembly} from "../../appRedux/actions/SubAssembly";
import AccessControl from "../AccessControl";

let context;
// const obj = {
//   manpower: Manpower,
// };

class MasterModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: 1,
      // documentData: [],
      visible: false,
      fields: {
        name: {
          value: '',
        },
        description: {
          value: ''
        }
      },
    };
    // console.log(this);
  }

  componentDidMount() {
    context = this;
  }

  componentWillReceiveProps(nextProps) {
  }

  showModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const {item} = this.props;
    this.props.fetchSubMasterFilter(item);
    // this.props.fetchSubDocumentFilter('Document');
    this.setState({
      visible: true,
    });
  };
  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };
  handleChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };
  edit = (id) => {
  };
  // getDocumentData = (data) => {
  // this.setState({ documentData: data });
  // };
  handleSubmit = (e) => {
    const {match, item, loading, resource} = this.props;
    // console.log('props', item, this.props);
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }
      switch (item) {
        case 'Manpower':
          if(this.props.subMaster) {
            this.props.manpower(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.manpower(values, false, resource, false, true);
            } else {
              this.props.manpower(values, false, resource, false);
            }
          }
          break;

        case 'Labour':
          this.props.labour(values, false, resource);
          break;

        case 'DocumentType':
          if(this.props.subMaster) {
            this.props.documentType(values, false, resource, true);
          } else {
            this.props.documentType(values, false, resource, false);
          }
          break;

        case 'Location':
          this.props.location(values, false, resource);
          break;

        case 'Client':
          this.props.client(values, false, resource);
          break;

        case 'AssetType':
          // console.log(this.props);
          if(this.props.pvModule) {
            this.props.assetType(values, false, resource, false, false, true);
          } else if(this.props.subMaster) {
            this.props.assetType(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.assetType(values, false, resource, false, true);
            } else {
              this.props.assetType(values, false, resource, false);
            }
          }
          break;

        case 'EquipmentSubType' :
          // console.log(this.props);
          // this.props.assetSubType(values, false, resource, false);
          if(this.props.subMaster) {
            this.props.assetSubType(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.assetSubType(values, false, resource, false, true);
            } else {
              this.props.assetSubType(values, false, resource, false);
            }
          }
          setTimeout(() => {
            if(this.props.handleSelectAssetType && this.props.form2)
              this.props.handleSelectAssetType(this.props.form2.getFieldValue(`assetDetails[${this.props.index}]['assetType']`));
          }, 500);
          break;

        case 'AssetMake' :
          // this.props.assetMake(values, false, resource, false);
          if(this.props.subMaster) {
            this.props.assetMake(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.assetMake(values, false, resource, false, true);
            } else {
              this.props.assetMake(values, false, resource, false);
            }
          }
          break;

        case 'Interval':
          if(this.props.subMaster) {
            this.props.interval(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.interval(values, false, resource, false, true);
            } else {
              this.props.interval(values, false, resource, false);
            }
          }
          break;

        case 'JobType':
          this.props.jobType(values, false, resource);
          break;

        case 'Owner':
          if(this.props.subMaster) {
            this.props.owner(values, false, resource, true);
          } else {
            this.props.owner(values, false, resource, false);
          }
          break;

        case 'SparePart':
          this.props.sparePart(values, false, resource);
          break;

        case 'SparePartType':
          if(this.props.subMaster) {
            this.props.sparePartType(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.sparePartType(values, false, resource, false, true);
            } else {
              this.props.sparePartType(values, false, resource, false);
            }
          }
          break;

        case 'Status':
          this.props.status(values, false, resource);
          break;

        case 'UnitOfMeasurement':
          if(this.props.subMaster) {
            this.props.unitOfMeasurement(values, false, resource, true);
          } else {
            if(this.props.superMaster) {
              this.props.unitOfMeasurement(values, false, resource, false, true);
            } else {
              this.props.unitOfMeasurement(values, false, resource, false);
            }
          }
          break;

        case 'Vendor':
          this.props.vendor(values, false, resource);
          break;

        case 'ActivityType':
          if(this.props.subMaster) {
            this.props.activityType(values, false, resource, true);
          } else {
            this.props.activityType(values, false, resource, false);
          }
          break;

        case 'FuelType':
          this.props.fuelType(values, false, resource);
          break;

        case 'ConditionOfAsset':
          this.props.conditionOfAsset(values, false, resource);
          break;

        case 'SubAssembly':

          this.props.subAssembly(values, false, resource);
          break;

        default:
          break;
      }

      if(!loading) {
        this.setState({visible: false});
        this.props.form.resetFields();
      }
    });

  };

  render() {
    const {
      item,
      isDisabled,
      subMasterFilters,
      data,
      history,
      match,
      title,
      loading,
      form,
      resource,
      authUser
    } = this.props;
    // console.log('=> ', this);
    const {getFieldDecorator} = form;
    const {visible} = this.state;
    return (
      <span style={{width: '20%', display: 'inline-block'}}>
        <Modal
          title={`Create ${item === 'Client' ? 'Sub Location' : item === 'Interval' ? 'Meter Unit' : item}`}
          visible={visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
        >
          <Spin spinning={loading}>
            <Card className={`gx-card-metrics`}
                  title={`${title} ${sanitizeFieldName(item === 'Client' ? 'subLocation' : item === 'Interval' ? 'meterUnit' : item)}`}>
              <Form onSubmit={this.handleSubmit} layout="vertical">

                {Object.keys(subMasterFilters).map((itm) => {
                  if(subMasterFilters[itm].type === 'Array' && subMasterFilters[itm].schema && this.props.hide && this.props.hide !== true) {
                    return <SubList key={itm} item={subMasterFilters[itm]} form={form} data={[]} title={title}
                                    resource={resource}/>
                  } else {
                    if(subMasterFilters[itm].type === 'Array' && subMasterFilters[itm].options.ref === 'Document') {
                      // return <DocumentList match={this.props.match} history={this.props.history} key={itm} item={subMasterFilters[itm]} form={form} data={[]} subDocumentFilters={subDocumentFilters} getDocumentData={this.getDocumentData}/>
                    }
                    return getFormFieldByType(subMasterFilters, itm, getFieldDecorator, {}, {resource: item})
                  }
                })}

                <Form.Item>
                  <Button type="primary" className="gx-mb-0" htmlType="button" onClick={this.handleSubmit}
                          loading={loading}>
                    CREATE
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Spin>

        </Modal>
        {
          this.props && this.props.disableAll ? <AccessControl resource={item} permissionNeeded={'c'}
                                                               roles={authUser ? authUser.roles : []}
                                                               render={(props) => {
                                                                 return <Button disabled={true} type="dashed"
                                                                                onClick={this.showModal}
                                                                                className={'master-modal-new-btn'}
                                                                                style={{
                                                                                  margin: '0',
                                                                                  marginTop: '0',
                                                                                  marginLeft: '10px',
                                                                                  width: 'calc(100% - 10px)'
                                                                                }}>New</Button>
                                                               }}/> :
            <AccessControl resource={item} permissionNeeded={'c'}
                           roles={authUser ? authUser.roles : []} render={(props) => {
              return <Button type="dashed" onClick={this.showModal} className={'master-modal-new-btn'} style={{
                margin: '0',
                marginTop: '0',
                marginLeft: '10px',
                width: 'calc(100% - 10px)'
              }}>New</Button>
            }}/>
        }
      </span>
    )
  }
}

const mapStateToProps = ({commonData, auth}) => {
  return {
    authUser: auth.authUser,
    subMasterFilters: commonData.subMasterFilters,
    // subDocumentFilters: commonData.subDocumentFilters,
    loading: commonData.loading,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    fetchSubMasterFilter,
    manpower,
    documentType,
    location,
    client,
    assetType,
    interval,
    jobType,
    owner,
    sparePart,
    sparePartType,
    status,
    unitOfMeasurement,
    vendor,
    activityType,
    fuelType,
    conditionOfAsset,
    labour,
    assetSubType,
    assetMake,
    subAssembly,
    // fetchSubDocumentFilter
  };
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    context.handleChange(changedFields);
  }
})(MasterModal);


export default connect(mapStateToProps, mapDispatchToProps())(CreateForm);


